import React from 'react';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { NotificationPanel } from '@/components/shared/NotificationPanel';
import UserProfileDropdown from './UserProfileDropdown';
import { Link } from 'react-router';
import { ThemeToggle } from './ThemeToggle';
import { ShiftControl } from './ShiftControl'; // Import the new component
import { useAuth } from '@/providers/AuthProvider';

interface HeaderProps {
  toggleSidebar: () => void;
}

export const Header: React.FC<HeaderProps> = ({ toggleSidebar }) => {
  const { user } = useAuth();
  return (
    <header className="sticky top-0 w-full flex items-center justify-between h-16 px-4 sm:px-6 bg-shell/95 backdrop-blur supports-[backdrop-filter]:bg-shell/60 z-30">
      <div className="flex items-center gap-3">
        <Button
          variant={'ghost'}
          size="icon"
          onClick={toggleSidebar}
          className="lg:hidden text-white"
          aria-label="Toggle sidebar"
        >
          <Menu className="h-5 w-5" />
        </Button>

        <Link
          to="/"
          className="flex items-center gap-2 hover:opacity-80 transition-opacity"
        >
          <div className="flex items-center space-x-4">
            <img className="h-12 w-auto" src="/ulaa-logo.png" />
            <div className="w-px h-6 bg-slate-200 hidden sm:block"></div>
            <h1 className="text-2xl md:text-3xl font-bold text-white tracking-wide font-inter drop-shadow-sm">
              <span className="text-white">Ulaa</span>{' '}
              <span className="text-white">Field</span>
              <span className="text-secondary">Ops</span>
            </h1>{' '}
          </div>
        </Link>
      </div>

      <div className="flex items-center gap-2 sm:gap-4">
        {user!.role === 'CREW' && (
          <ShiftControl /> // Add ShiftControl for CREW users
        )}

        <div className="flex items-center gap-1 sm:gap-2">
          {/* Theme Toggle - Hide on super small screens if needed */}
          <div className="hidden sm:block">
            <ThemeToggle />
          </div>

          {/* Notifications */}
          <div className="relative">
            <NotificationPanel />
          </div>

          {/* Profile */}
          <UserProfileDropdown />
        </div>
      </div>
    </header>
  );
};
